import styled from 'styled-components'

const LikeDislikeStyle = styled.div.attrs()`
	flex: 1;

	.like-unlike {
		flex: 1;
		margin-left: var(--sp1-5x);
		max-width: var(--sp10x);

		div {
			height: 3px;
			border-radius: 3px;

			&:last-child {
				margin-top: 4px;
			}
		}

		.like {
			background-color: var(--green);
		}

		.dislike {
			background-color: var(--red);
		}
	}

	i {
		font-size: 20px;
		margin-right: var(--spSize);

		&:before {
			transition: 0.3s;
		}
		
		&:hover {
			&:before {
				color:var(--purple);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
		.like-unlike {
			max-width: var(--sp8x);
		}
	}
`

export default LikeDislikeStyle
